import { AttachmentFileList } from 'owa-attachment-file-types';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { InlineImagePlugin } from 'owa-inline-image';
import { lazyCreateAttachments } from 'owa-mail-compose-store';
import ComposeViewState from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';

export default async function createAttachmentHandler(
    files: AttachmentFileList,
    inlineImagePlugin: InlineImagePlugin,
    viewState: ComposeViewState,
    properties: CreateAttachmentsProperties
): Promise<void> {
    const isPlainText = viewState.bodyType != 'HTML';
    const processInlineImageBeforeUpload = isPlainText
        ? null
        : inlineImagePlugin.processInlineImageBeforeUpload.bind(inlineImagePlugin);

    const createAttachments = await lazyCreateAttachments.import();
    createAttachments(files, viewState, properties, processInlineImageBeforeUpload);
}
